export default __webpack_public_path__ + "static/media/GR.dcbe2740.svg";